<template>
  <div id="customer-tabs" class="customer-tabs i-pl-9">
    <i-tabs :preselected-tab="currentSelectedTab" @tab-selected="onTabSelected">
      <template #tabs>
        <i-tab
          v-for="(tab, index) in visibleTabs"
          :key="index"
          :label="tab.label"
        >
        </i-tab>
      </template>
    </i-tabs>
  </div>
</template>

<script>
import { iTab, iTabs } from '@inscribe/signal';
import { mapGetters } from 'vuex';

export default {
  components: { iTab, iTabs },
  data: () => ({
    tabs: [],
  }),
  computed: {
    ...mapGetters({
      canUseCredit: 'canUseCredit',
    }),
    activeCreditRoutes() {
      return (
        this.$route.name === 'customer-credit' ||
        this.$route.name?.startsWith('customer-credit-granular-insight')
      );
    },
    activeCreditTransactionsRoutes() {
      return this.$route.name?.startsWith('customer-credit-transactions');
    },
    currentSelectedTab() {
      return (
        this.visibleTabs.findIndex((tab) => this.$route.name === tab.name) || 0
      );
    },
    visibleTabs() {
      return this.tabs.filter((tab) => tab.visible);
    },
  },
  watch: {
    canUseCredit: function () {
      this.setupTabItems();
    },
  },
  mounted() {
    this.setupTabItems();
  },
  methods: {
    setupTabItems() {
      this.tabs = [
        {
          label: 'Documents',
          name: 'customer-overview',
          visible: true,
        },
        {
          label: 'Transactions',
          name: 'customer-credit-transactions',
          visible: this.canUseCredit,
        },
        {
          label: 'Credit Insights',
          name: 'customer-credit',
          visible: true,
        },
      ];
    },
    onTabSelected(tabIndex) {
      const selectedTab = this.visibleTabs[tabIndex];
      if (selectedTab) {
        this.$router.push({
          name: selectedTab.name,
          params: { customer_id: this.$route?.params?.customer_id },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-tabs {
  position: relative;

  &::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background: $light-neutral-60;
  }
}
</style>
